module.exports = __webpack_public_path__ + "static/media/community-default-banner-picture.3babd68c.jpg";